import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { propsToClassKey } from "@mui/styles";
import { CSSProperties } from "react";
import { ColorUtils } from "../utils/ColorUtils";

export interface Props {
  label?: string;
  value: string;
  options: string[] | undefined;
  setValue: (value: string) => void;
  size: string;
  customStyle?: CSSProperties;
  readonly?: boolean;
  disabled?: boolean;
  name?: string;
  defaultValue?: string;
  className?: string;
}

export const SelectComponent = ({
  className,
  label,
  value,
  options,
  setValue,
  customStyle,
  size,
  readonly,
  disabled,
  name,
  defaultValue,
}: Props) => {
  return (
    <FormControl style={{ minWidth: "10em", marginLeft: "0.5em", ...customStyle }} variant="outlined" size="small">
      <InputLabel id="select-label">{label || "Option"}</InputLabel>
      <Select
        id="select-label"
        label={label || "Option"}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        readOnly={readonly}
        disabled={disabled}
        name={name ?? ""}
        defaultValue={defaultValue}
      >
        {options!.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
